import React, {FunctionComponent, ReactNode} from 'react';
import {Box} from '@mui/material';
import {
    APP_BAR_SEARCH_FIELD_MAX_WIDTH,
    APP_BAR_SEARCH_FIELD_MIN_WIDTH,
} from './search-field-styles';

export interface AppBarSearchFieldWidthBoxProps {
    noStartActions?: boolean;
    children: ReactNode;
}

/**
 * Constrains Nexus and System app-bar search fields to a shared limited width
 * (command-palette footprint + toggler), instead of expanding full slot width.
 */
const AppBarSearchFieldWidthBox: FunctionComponent<AppBarSearchFieldWidthBoxProps> = ({
    noStartActions = false,
    children,
}) => (
    <Box
        component="span"
        sx={{
            display: 'flex',
            alignItems: 'center',
            flexGrow: 1,
            minWidth: 0,
            justifyContent: noStartActions ? 'flex-start' : 'flex-end',
        }}
    >
        <Box
            sx={{
                width: '100%',
                minWidth: APP_BAR_SEARCH_FIELD_MIN_WIDTH,
                maxWidth: APP_BAR_SEARCH_FIELD_MAX_WIDTH,
            }}
        >
            {children}
        </Box>
    </Box>
);

export default AppBarSearchFieldWidthBox;
export {
    APP_BAR_SEARCH_FIELD_MAX_WIDTH,
    APP_BAR_SEARCH_FIELD_MIN_WIDTH,
    getAppBarSearchFieldInputPaddingSx,
} from './search-field-styles';
